export default __webpack_public_path__ + "static/media/a-tag-remove.ee5f3c98.svg";